// extracted by mini-css-extract-plugin
module.exports = {"EmojiPopoverList":"z-3pDv4m8TR8KBQfe6uyU"};